import React, {createRef, useState, useContext} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import __ from "lodash";
import MaterialTable from "@material-table/core";
import {
  defaultComponents,
  MaterialTableBody
} from '../../../../controls/Material-Table-Components';

import SystemContext from "../../../../SystemContext";

import AirportLookup from "../../../Airports/components/AirportsLookup";
import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import HandlingOrderLineValidator from "../../validators/HandlingOrderLineValidator";
import {MaskedNumber, MaskedTime, FlightNumber, DatePicker, MaskedText} from '../../../../controls';
import AircraftLookup from "../../../Aircraft/components/AircraftLookup";
import FlightLookup from "../../../Flights/components/FlightOnDLookup";
import { useTheme } from '@material-ui/core';


const dateFormat = "DD/MM/YYYY";


const HandlingOrderLineEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('HandlingOrder.AddLine', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const props = {
    ..._props
  }
  const {classes} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const orderLines = props.orderRecord.lines;
  const orderAirport = props.orderRecord.airportCode;

  const minDate = moment.utc().add(1,'day');
  const initialDate = minDate.toISOString();

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const formatChars={
      "U": "[A-Z]",
      "X": "[A-Za-z]",
      "A": "[A-Z0-9]",
      "a": "[A-Za-z0-9]",
      "i": "[A-Za-z0-9]-",
      "9": "[0-9]",
      "D": "[0-9.]",
      "-": "-",
      "x": "."
    }
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(HandlingOrderLineValidator, false);
    //const  lastAirport = Array.isArray(orderLines) && orderLines.length > 0?orderLines[orderLines.length - 1].destinationAirportCode:'';

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(120,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Flight Number",
        field: "flightNumber",
        initialEditValue: "",
        editComponent: (props) => (
          <FlightLookup
            returnType="object"
            value={props.value}
            airportCode={orderAirport}
            fromDate={minDate.format("YYYY-MM-DD")}
            orderLines={orderLines}
            onChange={(obj) => {
              if (obj.data) {
                const data = {
                  ...props.rowData,
                  tripLegUuid: obj.data.tripLegUuid,
                  airportCode: orderAirport,
                  direction: orderAirport===obj.data.originAirportCode?'OUT':'IN',
                  scheduledTimeUTC:orderAirport===obj.data.originAirportCode?obj.data.scheduledDepartureTimeUTC:obj.data.scheduledArrivalTimeUTC,
                  airlineCode: obj.data.airlineCode,
                  flightNo: obj.data.flightNo,
                  flightNumber: obj.data.airlineCode + obj.data.flightNo,
                  aircraftTailNumber: obj.data.aircraftReg,
                  originAirportCode: obj.data.originAirportCode,
                  arrivalDate: obj.data.arrivalDate,
                  scheduledArrivalTimeUTC: obj.data.arrivalTime,
                  destinationAirportCode: obj.data.destinationAirportCode,
                  departureDate: moment.utc(obj.data.scheduledDepartureTimeUTC).format("YYYY-MM-DD"),
                  scheduledDepartureTimeUTC: moment.utc(obj.data.scheduledDepartureTimeUTC).format("HH:mm"),
                  cargo: obj.data.cargo,
                };
                props.onRowDataChange(data);
              } else {
                props.onChange(obj.value);
              }
            }}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(130,2,undefined,undefined,undefined,undefined,false),
        title: "Departure Date",
        field: "departureDate",
        sorting: false,
        editComponent: (props) => (
          <DatePicker
            value={props.value}
            initialValue={props.rowData.arrivalDate || initialDate}
            minDate={props.rowData.arrivalDate || minDate}
            defaultValue={props.rowData.arrivalDate || initialDate}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        ),
        render: (rowData) => (
          <div style={{paddingLeft:12}}>{moment(rowData.departureDate).format(dateFormat)}</div>
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(90,2,undefined,undefined,undefined,undefined,false),
        title: "STD UTC",
        field: "scheduledDepartureTimeUTC",
        type: "time",
        emptyValue: 0,
        defaultValue: 0,
        editComponent: (props) => (
          <MaskedTime
            value={props.value}
            onChange={props.onChange}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,undefined,undefined,false),
        title: "ADEP",
        field: "originAirportCode",
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,undefined,undefined,false),
        title: "ADES",
        field: "destinationAirportCode",
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(130,2,undefined,undefined,undefined,undefined,false),
        title: "Arrival Date",
        field: "arrivalDate",
        sorting: false,
        editComponent: (props) => (
          <DatePicker
            value={props.value}
            initialValue={minDate}
            minDate={minDate}
            defaultValue={initialDate}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        ),
        render: (rowData) => (
          <div style={{paddingLeft:12}}>{moment(rowData.arrivalDate).format(dateFormat)}</div>
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(90,2,undefined,undefined,undefined,undefined,false),
        title: "STA (UTC)",
        field: "scheduledArrivalTimeUTC",
        type: "time",
        emptyValue: 0,
        defaultValue: 0,
        editComponent: (props) => (
          <MaskedTime
            value={props.value}
            onChange={props.onChange}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(90,2,undefined,undefined,undefined,undefined,false),
        title: "A/C Type",
        field: "aircraftType",
        initialEditValue: "B747F",
        editable: "never",
      },
      {
        ...baseColumn,
        ...ColumnWidth(100,2,undefined,undefined,undefined,undefined,false),
        title: "Registration",
        field: "aircraftTailNumber",
        initialEditValue: "TF-AMP",
        editComponent: (props) => (
          <AircraftLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(229,2,undefined,undefined,undefined,undefined,false),
        title: "Cargo",
        field: "cargo",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(50)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            forceUpperCase={true}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        ),
      },
    ];
  };

  const onDragEnd = (dragProps) => {
    return;
  }

  const getOrderPeriod = (orderLines) => {
    let periodFrom = null;
    let periodTo = null;

    if (orderLines && Array.isArray(orderLines)) {
      const dateFormat = "YYYY-MM-DD";
      orderLines.forEach(line => {
        const arrivalDate = moment(line.arrivalDate, );
        const departureDate = moment(line.departureDate, dateFormat);
        if (!periodFrom || moment(periodFrom, dateFormat).isAfter(arrivalDate))
          periodFrom = arrivalDate.format(dateFormat);
        if (!periodTo || moment(periodTo, dateFormat).isBefore(departureDate))
          periodTo = departureDate.format(dateFormat);
      })
    }

    return {periodFrom, periodTo};
  }

  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.fuelOrderLineEditor}>
          <MaterialTable
            tableRef={tableRef}
            data={orderLines}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              onEditModeChanged: (editMode)=> {
                if (props.changeButtonState) {
                  const changes = {
                    save: {disabled: false, hidden: false},
                    send: {disabled: false, hidden: false},
                  }
                  if (editMode) {
                    changes['save'] = {disabled: true, hidden: false}
                    changes['send'] = {disabled: true, hidden: false}
                  }
                  props.changeButtonState(changes);
                }
              },
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={300}
                  headerHeight={46}
                />
              ),
            }}
            title="Handling Order Lines"
            columns={getColumns({...props, canEdit: state.canEdit})}
            actions={[
            ]}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    if (Array.isArray(orderLines)) {
                      orderLines.push(newData);
                      const {periodFrom, periodTo} = getOrderPeriod(orderLines);
                      props.onChange({record: {...props.orderRecord, periodFrom, periodTo, lines: orderLines}, oldRecord: props.orderRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  })
                  : undefined,
              onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    const lineIdx = __.findIndex(orderLines, (trip) => {
                      const newRecord = __.omit(trip, ["tableData"]);
                      const oldRecord = __.omit(oldData, ["tableData"]);
                      return __.isEqual(newRecord, oldRecord);
                    });
                    if (lineIdx >= 0) {
                      orderLines[lineIdx] = newData;
                      const {periodFrom, periodTo} = getOrderPeriod(orderLines);
                      props.onChange({record: {...props.orderRecord, periodFrom, periodTo, lines: orderLines}, oldRecord: props.orderRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  }),
              onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    const lineIdx = __.findIndex(orderLines, (trip) => {
                      const newRecord = __.omit(trip, ["tableData"]);
                      const oldRecord = __.omit(oldData, ["tableData"]);
                      return __.isEqual(newRecord, oldRecord);
                    });
                    if (lineIdx >= 0) {
                      orderLines.splice(lineIdx, 1);
                      props.onChange({record: {...props.orderRecord, lines: orderLines}, oldRecord: props.orderRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  }),
            }}
        />
      </div>
  );
}

export default HandlingOrderLineEditor;
